// extracted by mini-css-extract-plugin
export default {"heart":"Likee-module__heart--_bl0_","icon":"Likee-module__icon--TjsEr","bg":"Likee-module__bg--cO_7s"};